import { render, staticRenderFns } from "./cszyjsxy.vue?vue&type=template&id=3504ead2&scoped=true&"
import script from "./cszyjsxy.vue?vue&type=script&lang=js&"
export * from "./cszyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./cszyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cszyjsxy.vue?vue&type=style&index=1&id=3504ead2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3504ead2",
  null
  
)

export default component.exports